import React from 'react';

export default function ({ feedItem, eleRef }) {
    return (
<section className="main_container_block_feeds">
                      <div className="main_block_container_feed">
                        <div className="block_container_feed_heading_text R15_61" role='heading' tabIndex={0} aria-label={feedItem.subTitle}>
                         {feedItem.subTitle?feedItem.subTitle:''}
                        </div>
                        <div className="content-div-box-artical">
                          <div className="content-div_view_artical">
                            <img
                              src={feedItem.backgroundImage?feedItem.backgroundImage:'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/vaccinationbg.jpeg'}
                              alt= {feedItem.data[0].title} title={feedItem.data[0].title}
                              onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png"}}
                            />
                          </div>
                          <div className="vaccination_traker_feeds_main">
                            <div className="viccination_tolerance">
                              <h2 className="B15_42" role='heading' tabIndex={0} aria-label={feedItem.data[0].title}>
                                {feedItem.data[0].title}
                              </h2>
                              <p className="R15_42" role='heading' tabIndex={0} aria-label={`Pregnancy week range: ${feedItem.data[0].startWeek?feedItem.data[0].startWeek:''} weeks to ${feedItem.data[0].endWeek?feedItem.data[0].endWeek:''} weeks`}> {feedItem.data[0].startWeek?feedItem.data[0].startWeek:''} weeks to {feedItem.data[0].endWeek?feedItem.data[0].endWeek:''} weeks </p>
                            </div>
                            <div className="viccination_tolerance_content">
                              <div className="vaccinaton-due_dates vaccination_border-y">
                                <div className="left_vaccinatioin_due_one">
                                  <span className="dueon_text M13_21">
                                    Due on :&nbsp;
                                  </span>
                                  <span className="dueon_Date_text">        
                                  {feedItem.data[0].dueOn?feedItem.data[0].dueOn:''}
                                  </span>
                                </div>
                                <div className="vaccination_mark-right">
                                  <div className="mark_text-view">
                                  <a className="gtm-markdone" href={'https://parenting.firstcry.com/tools/pregnancy-checkup-schedule/updateDetails/' + feedItem.data[0].title.replace(" ","_").toString().toLowerCase() + '/'+ feedItem.data[0].id} tabIndex={0} aria-label='mark done for this test'>
                                    Mark Done
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="vaccinaton-due_dates">
                              <div className="left_vaccinatioin_due_one">
                                <span className="dueon_text M13_21">
                                  Reminder set for :&nbsp;
                                </span>
                                <span className="dueon_Date_text_second M13_pink pis-remDate">
                                  
                                {feedItem.data[0].reminderDate?feedItem.data[0].reminderDate:''}
                                </span>
                              </div>
                              <div className="vaccination_mark-right">
                                <div className="mark_text-view_calendar">
                                  <img
                                    src={feedItem.icon?feedItem.icon:''}
                                    alt="calendar" title='calendar'
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="my_baby_question_view pisBlock">
                              <div className="my_baby_question_ask">
                                <span className="my_baby_question_disc R13_61">
                                  
                                {feedItem.data[0].desc?feedItem.data[0].desc:''}
                                </span>
                              </div>
                              <a href={feedItem.data[0].url?feedItem.data[0].url:''} className="gtm-pis-read readmorelink R14_link" tabIndex={0} aria-label='read more about this test'>
                                Read more
                              </a>
                            </div>
                            <div className="overdue_container fc-mx-0">
                              <div className="vacci_tools">
                                <span className="overdue_text one_ha_1">
                                  
                                {feedItem.data[0].dueTestCount?feedItem.data[0].dueTestCount:'0'}
                                </span>
                                <span className="overdue_text_text M14_42">
                                  
                                  Overdue
                                </span>
                              </div>
                              <div className="vacci_tools">
                                <span className="overdue_text one_ha_2">
                                  
                                {feedItem.data[0].upcomingTestCount?feedItem.data[0].upcomingTestCount:'0'}
                                </span>
                                <span className="overdue_text_text M14_42">
                                  
                                  Upcoming
                                </span>
                              </div>
                              <div className="vacci_tools">
                                <span className="overdue_text one_ha_3">
                                  
                                {feedItem.data[0].givenTestCount?feedItem.data[0].givenTestCount:'0'}
                                </span>
                                <span className="overdue_text_text M14_42">
                                  
                                  Done
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
    )}
